import React from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"

const CustomBorderedText = (props) => {
    const { label, color, backgroundColor, touchable, fontSize } = props
    const containerStyle = {
        ...styles.container,
        backgroundColor: backgroundColor ?? baseColors.green.light
    }

    if (!touchable) {
        return (
            <View style={containerStyle}>
                <OpenSansText
                    style={{ textTransform: "uppercase", color: color ?? baseColors.green.dark }}
                    defaultFontFamily={baseFontFamily.OpenSansBold}
                    fontSize={fontSize ?? 12}
                >
                    {label}
                </OpenSansText>
            </View>
        )
    }

    return (
        <TouchableOpacity style={containerStyle} onPress={() => console.log("Pressed")}>
            <OpenSansText
                style={{ textTransform: "uppercase", color: color ?? baseColors.green.dark }}
                defaultFontFamily={baseFontFamily.OpenSansBold}
                fontSize={RFValue(12)}
            >
                {label}
            </OpenSansText>
        </TouchableOpacity>
    )
}

export default CustomBorderedText
